import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { HpaJourneyShell } from "./components";
import "./hpa.css";
import "./hpa-assessment.css";

/**
 * Block 11.2 · § 20 · Pause Flow
 * Bestätigung nach erfolgreichem Pause-Request, mit klarem Weiterweg.
 */
export default function HpaPaused() {
  return (
    <>
      <SEO title="HPA · Pausiert" description="HPA pausiert" path="/hpa/paused" />
      <HpaJourneyShell testid="hpa-paused">
        <div className="hpa-overline mb-6">SAT HPA™ · Pause</div>
        <h1
          className="hpa-headline text-3xl md:text-5xl mb-8"
          data-testid="hpa-paused-headline"
        >
          Deine HPA wartet <em>auf dich</em>.
        </h1>
        <p className="hpa-lede text-base md:text-lg leading-relaxed max-w-xl mb-14">
          Alles bis hierhin ist gespeichert. Du kannst jederzeit genau hier
          weitermachen.
        </p>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <Link
            to="/hpa"
            className="hpa-btn-primary"
            data-testid="hpa-paused-cta-home"
          >
            Zur HPA-Übersicht
          </Link>
          <Link
            to="/hpa/assessment"
            className="hpa-btn-ghost"
            data-testid="hpa-paused-cta-resume"
          >
            Direkt weitermachen
          </Link>
        </div>
      </HpaJourneyShell>
    </>
  );
}
